import BulkEmployersUploadDetails from "./BulkEmployersUploadDetails";

const BulkEmployersRequests = {
	BulkEmployersUploadDetails
}

export default BulkEmployersRequests;